document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".bf-banner");
  const shadow = document.querySelector(".bf-banner-shadow");
  const root = document.documentElement;
  const body = document.body;
  const mainWrapper = document.querySelector("main.wrapper");

  if (!banner || !mainWrapper) return;

  if (!body.classList.contains("has-banner")) {
    body.classList.add("has-banner");
  }

  banner.querySelectorAll("img").forEach((img) => {
    img.setAttribute("data-no-lazy", "true");
    img.classList.add("no-lazy");
    img.loading = "eager";
  });

  banner.classList.add("show");
  if (shadow) shadow.classList.add("show");

  function updateBannerHeight() {
    const height = banner.offsetHeight || 0;
    root.style.setProperty("--banner-height", `${height}px`);
  }

  updateBannerHeight();

  window.addEventListener("resize", updateBannerHeight);

  new MutationObserver(updateBannerHeight).observe(banner, {
    childList: true,
    subtree: true,
  });
});

document.querySelectorAll("li.nav-item_has-sub").forEach((item) => {
  item.addEventListener("mouseenter", () =>
    document.body.classList.add("sub-menu-open")
  );
  item.addEventListener("mouseleave", () =>
    document.body.classList.remove("sub-menu-open")
  );
});
